import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Button,
} from 'reactstrap';
import { callApi } from '../../../utils';
import { showError, showInfo } from '../../../actions/notificationActions';

class EditMerchantFaqModal extends Component {
  constructor(props) {
    super(props);
    const faq = props.faq || {};
    this.state = {
      question: faq.question || '',
      answers: faq.answers || [],
      category: faq.category || '',
      faqId: faq.id || null,
      loading: false,
      answerInput: '',
    };
  }

  setInput = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleAnswerInput = (e) => {
    this.setState({ answerInput: e.target.value });
  };

  addAnswer = () => {
    const { answerInput, answers } = this.state;
    if (answerInput.trim()) {
      this.setState({
        answers: [...answers, answerInput],
        answerInput: '',
      });
    }
  };

  removeAnswer = (index) => {
    const { answers } = this.state;
    this.setState({
      answers: answers.filter((_, i) => i !== index),
    });
  };

  updateFaq = (e) => {
    e.preventDefault();

    if (this.state.loading) return;

    const { question, answers } = this.state;

    if (!question.trim()) {
      this.props.dispatch(showError('Question is required'));
      return;
    }

    if (answers.length === 0) {
      this.props.dispatch(showError('At least one answer is required'));
      return;
    }

    const prompt = `Are you sure you want to update this FAQ?`;

    if (!window.confirm(prompt)) return;

    this.setState({ loading: true });

    callApi(
      `/merchants/faq/${this.state.faqId}`,
      {
        question: this.state.question,
        answers: this.state.answers,
        category: this.state.category,
      },
      'put'
    )
      .then((res) => {
        this.props.close();
        this.props.dispatch(showInfo('FAQ updated successfully'));
        this.props.refreshFaq();
      })
      .catch((err) => {
        this.props.dispatch(showError(err.message || 'Failed to update FAQ'));
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const { question, answers, category, loading, answerInput } = this.state;

    return (
      <Modal
        size="lg"
        isOpen={this.props.open}
        toggle={this.props.close}
        backdrop="static"
      >
        <ModalHeader toggle={this.props.close}>Edit FAQ</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <FormGroup>
                <Label>Question *</Label>
                <Input
                  onChange={this.setInput}
                  value={question}
                  name="question"
                  placeholder="Enter question"
                  type="textarea"
                  required
                />
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label>Category</Label>
                <Input
                  onChange={this.setInput}
                  value={category}
                  name="category"
                  type="text"
                ></Input>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label>Add Answer *</Label>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Input
                    onChange={this.handleAnswerInput}
                    value={answerInput}
                    placeholder="Type an answer"
                    type="textarea"
                    style={{ flex: 1 }}
                  />
                  <Button
                    color="info"
                    onClick={this.addAnswer}
                    style={{ height: 'fit-content', marginTop: '5px' }}
                  >
                    Add
                  </Button>
                </div>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label>Answers ({answers.length})</Label>
                <div
                  style={{
                    maxHeight: '250px',
                    overflowY: 'auto',
                    border: '1px solid #ddd',
                    borderRadius: '4px',
                    padding: '10px',
                    minHeight: '100px',
                  }}
                >
                  {answers.length > 0 ? (
                    answers.map((answer, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          padding: '10px',
                          marginBottom: '8px',
                          background: '#f5f5f5',
                          borderRadius: '4px',
                          border: '1px solid #e0e0e0',
                        }}
                      >
                        <span style={{ flex: 1, wordBreak: 'break-word' }}>
                          {answer}
                        </span>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={() => this.removeAnswer(index)}
                          style={{ marginLeft: '10px' }}
                        >
                          Remove
                        </Button>
                      </div>
                    ))
                  ) : (
                    <p style={{ color: '#999', textAlign: 'center' }}>
                      No answers added yet
                    </p>
                  )}
                </div>
              </FormGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={this.props.close}>
            Cancel
          </Button>
          <Button color="primary" onClick={this.updateFaq} disabled={loading}>
            {loading ? 'Updating...' : 'Update FAQ'}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect()(EditMerchantFaqModal);
